import styled from 'styled-components';
var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-578wft-0"
})([""]);
export default Content;